import {
    RiOrganizationChart,
    RiGraduationCapLine,
    RiBriefcase4Line,
} from "react-icons/ri";
import { EXPERIENCE } from "./siteData";

const ResumesData = [
    {
        key: "1",
        Icon: <RiBriefcase4Line size={20} />,
        Title: "Experience",
        Datas: EXPERIENCE.map((e, i) => ({
            key: e.key,
            SubTitle: e.subTitle,
            Company: e.company,
            Year: e.year,
            Description: e.description,
            Metrics: e.metrics,
        })),
    },
    {
        key: "2",
        Icon: <RiGraduationCapLine size={20} />,
        Title: "Education",
        Datas: [
            {
                key: "1",
                SubTitle: "Bachelor of Science in Computer Science",
                Company: "Bina Nusantara University",
                Year: "August 2020 – April 2024",
                Description:
                    "Specialized in software engineering, algorithms, and database systems with a strong academic foundation in system design and data structures.",
                Metrics: ["GPA 3.95 / 4.0", "High Distinction"],
            },
        ],
    },
    {
        key: "3",
        Icon: <RiOrganizationChart size={20} />,
        Title: "Leadership & Organization",
        Datas: [
            {
                key: "1",
                SubTitle: "General Manager — Design & Development Commission",
                Company: "HIMTI · Bina Nusantara University",
                Year: "January 2022 – February 2023",
                Description:
                    "Directed the Design & Development Commission, overseeing organizational web platforms, launching event-specific websites, coordinating cross-functional collaboration, and mentoring team members across a 50+ person student organization.",
                Metrics: [
                    "50+ Member Organization",
                    "Multiple Event Platforms Launched",
                    "Cross-Team Leadership",
                ],
            },
            {
                key: "2",
                SubTitle: "Web Development Activist",
                Company: "HIMTI · Bina Nusantara University",
                Year: "March 2021 – January 2022",
                Description:
                    "Led development and maintenance of HIMTI-owned web platforms, delivering new websites from design handoff through production deployment.",
                Metrics: [],
            },
            {
                key: "3",
                SubTitle: "Web Developer Coordinator — HISHOT 2021",
                Company: "HIMTI · Bina Nusantara University",
                Year: "April 2021 – November 2021",
                Description:
                    "Coordinated end-to-end web development for HISHOT 2021, aligning design, development, and publication teams to deliver the event platform on schedule.",
                Metrics: [],
            },
            {
                key: "4",
                SubTitle: "Web Developer — Computer Run",
                Company: "HIMTI · Bina Nusantara University",
                Year: "May 2021 – December 2021",
                Description:
                    "Developed the Computer Run event website, translating UI designs into a production-ready web platform.",
                Metrics: [],
            },
        ],
    },
];

export default ResumesData;
